import dayjs from 'dayjs'
import { CustomColumnGridConfig } from '../types'
import { Box, Typography } from '@mui/material'

import { renderAlertWithMutedIndication } from '@/utils/mutedAlertRenderer'

const fmt = (v: any) => (v ? dayjs(v).format('DD/MM/YYYY') : '-')

const pickConsumerName = (row: any) => row.name ?? row.consumerName
const pickDate = (row: any) =>
  row.date ?? row.createdAt ?? dayjs().format('DD/MM/YYYY')
const pickActivity = (row: any) => row.activity ?? row.activityType ?? 'פעילות'
const pickActivityDescription = (row: any) =>
  row.activityDescription ?? row.description ?? 'תיאור פעילות'

// const getStatusColor = (status: string) => {
//   switch (status?.toLowerCase()) {
//     case 'פתוח':
//     case 'open':
//       return '#8577E6'
//     case 'בתהליך':
//     case 'in-progress':
//     case 'בחירה':
//       return '#F79268'
//     case 'בוצע':
//     case 'completed':
//       return '#46BE8B'
//     case 'סגור':
//     case 'closed':
//       return '#FCEEEE'
//     case 'בתהליך':
//     case 'working':
//       return '#F79268'
//     case 'נסגר':
//     case 'shut':
//       return '#46BE8B'
//     case 'בטיפול':
//     case 'in-treatment':
//       return '#F79268'
//     default:
//       return '#F2FCEE'
//   }
// }

// const getStatusTextColor = () => {
//   return '#EFF2F7'
// }

const parseRowDate = (valOrRow: any): number => {
  const val = valOrRow && typeof valOrRow === 'object' ? (valOrRow?.date ?? valOrRow?.createdAt) : valOrRow
  if (!val) return 0
  if (val instanceof Date) return val.getTime()
  const s = String(val).trim()
  const dmy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(s)
  if (dmy) {
    return new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1])).getTime()
  }
  const parsed = new Date(s).getTime()
  return isNaN(parsed) ? 0 : parsed
}

const generalColumns: CustomColumnGridConfig[] = [
  {
    field: 'date',
    headerName: 'תאריך',
    minWidth: 120,
    flex: 1,
    filter: { type: 'date' },
    filterable: true,
    sortComparator: (v1: any, v2: any) => parseRowDate(v1) - parseRowDate(v2),
    renderCell: (params: any) => fmt(pickDate(params.row)),
  },
  {
    field: 'id',
    headerName: 'מספר מד',
    minWidth: 120,
    flex: 1,
    filter: { type: 'search' },
    filterable: true,
    valueGetter: (_value, row) => String(row?.meterNumber ?? row?.meterId ?? row?.id ?? ''),
    renderCell: (params: any) => String(params.row?.meterNumber ?? params.row?.meterId ?? params.row?.id ?? '-'),
  },
  {
    field: 'name',
    headerName: 'שם הצרכן',
    minWidth: 150,
    flex: 1.2,
    filter: { type: 'search' },
    filterable: true,
    valueGetter: (_value, row) => String(row?.name ?? row?.consumerName ?? ''),
    renderCell: (params: any) => pickConsumerName(params.row) ?? '-',
  },
  {
    field: 'activity',
    headerName: 'פעילות',
    minWidth: 120,
    flex: 1,
    filter: { type: 'options' },
    filterable: true,
    valueGetter: (_value, row) => String(row?.activity ?? row?.activityType ?? ''),
    renderCell: (params: any) => pickActivity(params.row) ?? '-',
  },
  {
    field: 'activityDescription',
    headerName: 'תיאור פעילות',
    minWidth: 200,
    flex: 1.5,
    filter: { type: 'search' },
    filterable: true,
    valueGetter: (_value, row) => String(row?.activityDescription ?? row?.description ?? ''),
    renderCell: (params: any) => {
      const desc = pickActivityDescription(params.row) ?? '-'
      if (params.row.activity === 'התראה') {
        return renderAlertWithMutedIndication(desc, params.row)
      }
      return desc
    },
  },
  {
    field: 'status',
    headerName: 'סטטוס',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    filter: { type: 'options' },
    filterable: true,
    valueGetter: (_value, row) => String(row?.status ?? ''),
    renderCell: (params: any) => {
      const val = params.value ?? params.row.status
      if (!val || val === '—' || val === '-') return '-'

      if (val === 'בתהליך') {
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: 1.5,
              borderRadius: '20px',
              bgcolor: '#F79268',
              color: '#fff',
              fontSize: '13px',
              fontWeight: 500,
              height: '26px',
            }}
          >
            בתהליך
          </Box>
        )
      }

      if (val === 'בוצע') {
        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: 1.5,
              borderRadius: '20px',
              bgcolor: '#46BE8B',
              color: '#fff',
              fontSize: '13px',
              fontWeight: 500,
              height: '26px',
            }}
          >
            בוצע
          </Box>
        )
      }

      return (
        <Typography sx={{ fontSize: '13.5px', color: '#9CA3AF' }}>
          {val}
        </Typography>
      )
    },
  },
]

export default generalColumns
